import { useMutation, useQuery } from '@tanstack/react-query';

import service from '@/services';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { SOURCE_TYPE } from '@/types/feedbackConst';

import { getIntegrationQueryKeys } from '../../integrationUtils';

export const useAppleAppStore = (enable: boolean) => {
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const workspace_alias = currWorkspace?.alias;
  if (!workspace_alias) throw new Error('Workspace alias is required');

  const queryKeys = getIntegrationQueryKeys(
    SOURCE_TYPE.APPLE_APP_STORE,
    workspace_alias,
  );

  const { data, refetch } = useQuery({
    queryKey: queryKeys,
    queryFn: () => service.appleAppStore.getAppleAppStoreInfos(workspace_alias),
    enabled: enable,
  });

  const { mutate: disconnectAppleAppStoreMutation } = useMutation({
    mutationFn: ({ app_id }: { app_id: string }) =>
      service.appleAppStore.disconnectApp(app_id),
    onSuccess: () => {
      refetch();
    },
  });

  return {
    appleAppStoreInfo: data,
    disconnectAppleAppStoreMutation,
    refetch,
  };
};
